<template>
    <p :style="{display: display}">
        <span class="icon-text" v-if="$slots.default">
            <el-tooltip v-if="tooltip" class="item" effect="dark" :content="tooltip" placement="top">
                <i class="mr-5" :class="[iconClass, 'pointer']"></i>
            </el-tooltip>
            <i v-else class="mr-5" :class="iconClass"></i>
            <slot></slot>
        </span>
    </p>
</template>
<script>
    export default {
        name: 'pIcon',
        props: {
            iconName: String,   // 有地方还在用，先保留
            icon: String,        // 方便使用font-icon
            tooltip: String,      // tooltip的内容
            display: String     // display方式
        },
        computed: {
            iconClass () {
                if (this.iconName) {
                    let iconName = this.iconName
                    return iconName ? 'icon icon-' + iconName : ''
                } else if (this.icon) {
                    let iconName = this.icon
                    return iconName ? 'el-icon-' + iconName : ''
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    p {
        i.icon {
            width          : 16px;
            height         : 19px;
            margin-right   : 5px;
            display        : inline-block;
            vertical-align : middle;
            background     : url('~images/icons/p-icon.png') no-repeat 0 0;
            &-phone {
                background-position : 0 0;
            }
            &-list {
                background-position : 0 -36px;
            }
            &-email {
                background-position : 0 -69px;
            }
            &-clock {
                background-position : 0 -104px;
            }
            &-white-phone {
                background-position : 0 -138px;
            }
        }
        i.pointer {
            cursor : pointer;
        }
        .icon-text {
            word-break : break-all;
        }
    }
</style>


// WEBPACK FOOTER //
// pIcon.vue?fb9d8982